import React from 'react';
import styles from './Divider.module.scss';

const Divider = () => (
  <div className={styles.container} />
);

export default Divider;
